import React from 'react';
import LandingSection from './LandingSection';
import SimpleHeader from './SimpleHeader';
export default (function (_ref) {
  var article = _ref.article,
      skipToContentTooltip = _ref.skipToContentTooltip;
  var image = article.image;

  if (image) {
    return React.createElement(LandingSection, {
      article: article,
      titleAttribute: skipToContentTooltip
    });
  }

  return React.createElement(SimpleHeader, {
    article: article
  });
});